export default __webpack_public_path__ + "static/media/landingimage2.bb1b1bf9.png";